import { FormikValues } from "formik";
import React from "react";
import { Label } from "../Label";
import { InputWrapper } from "../TextWrapper";
import { Field, StyledInput } from "./style";

interface TextFieldProps {
  name: string;
  label: string;
  value: FormikValues;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  required?: boolean;
  placeholder?: string;
  error?: string;
  type?: "email" | "password" | "date" | "color";
}

export const TextField: React.FC<TextFieldProps> = (props) => {
  return (
    <InputWrapper>
      <Label
        error={props.error}
        required={props.required}
        name={props.name}
        label={props.label}
      />

      <Field
        id={props.name}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        error={Boolean(props.error)}
        fullWidth={true}
        inputComponent={StyledInput}
        placeholder={props.placeholder}
        type={props.type ?? "text"}
      />
    </InputWrapper>
  );
};
